import {useEffect,useState} from 'react';
import {useLocation} from "react-router-dom";
import DashboardHeader from '../../components/DashboardHeader';
import '../styles.css';
import CreateSponsorform from "./create-form";

function NewSponsor(props) {

    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="Back" link="/sponsors" />

            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Create New Sponsor </h2>



                </div>
                <CreateSponsorform token={props.token}/>
            </div>
        </div>
    );
}

export default NewSponsor;